import {Button, Loading} from '@hm/fundamental'
import {
  mdiCheck,
  mdiClose,
  mdiFolderPlusOutline,
  mdiHomeOutline,
  mdiPlusCircleOutline
} from '@mdi/js'

export type EditAction = 'setHomePage' | 'addFolder' | 'addFeature' | 'cancel' | 'confirm'

const HOME_PAGE_TOGGLED_CLASS =
  'bg-button_background_toggled text-[#29333d] border-1px border-transparent'

interface EditModeActionBarProps {
  isHomePageMode: boolean
  isPending?: boolean
  onAction: (action: EditAction) => void
}

export const EditModeActionBar: React.FC<EditModeActionBarProps> = ({
  isHomePageMode,
  isPending,
  onAction
}) => {
  return (
    <div className="flex gap-2 px-6 py-2" data-cy="edit_mode_action_bar">
      <Button
        icon={mdiHomeOutline}
        variant={isHomePageMode ? 'primary' : 'secondary'}
        colorClass={isHomePageMode ? HOME_PAGE_TOGGLED_CLASS : undefined}
        disabled={isPending}
        onClick={() => onAction('setHomePage')}
        data-cy="edit_action_set_home_page"
      />
      <Button
        icon={mdiFolderPlusOutline}
        variant="secondary"
        disabled={isPending}
        onClick={() => onAction('addFolder')}
        data-cy="edit_action_add_folder"
      />
      <Button
        icon={mdiPlusCircleOutline}
        variant="secondary"
        disabled={isPending}
        onClick={() => onAction('addFeature')}
        data-cy="edit_action_add_feature"
      />
      <div className="flex-1" />
      <Button
        icon={mdiClose}
        variant="secondary"
        disabled={isPending}
        onClick={() => onAction('cancel')}
        data-cy="edit_action_cancel"
      />
      <Button
        icon={isPending ? <Loading size="xsmall" variant="secondary" /> : mdiCheck}
        variant="primary"
        disabled={isPending}
        onClick={() => onAction('confirm')}
        data-cy="edit_action_confirm"
      />
    </div>
  )
}
